import { Redirect } from "expo-router";
import { useEffect } from "react";
import { useFarcasterContext } from "@hooks/useFarcasterContext";

export default function Index() {
  const { isInMiniApp, isLoading } = useFarcasterContext();

  useEffect(() => {
    // In Farcaster Mini App: use window.location since History API doesn't work
    if (isInMiniApp === true) {
      window.location.replace("/home");
    }
  }, [isInMiniApp]);

  // Still checking Mini App status
  if (isLoading) {
    return null;
  }

  // In Mini App: window.location.replace will handle navigation
  if (isInMiniApp) {
    return null;
  }

  // Not in Mini App: use normal routing
  return <Redirect href="/(app)/(tabs)" />;
}
